import React from "react";

import renderChildren from "../../../../utils/renderChildren";

import Form from "../Form/Form";

export default function FormFields({ fields, renderLabel, ...props }) {
	return (
		<Form.Group widths="equal">
			{fields
				.filter(({ name, condition }) => !condition || condition?.({ name, ...props }))
				.map(({ name, label, field, style }) => (
					<div key={name} className="field" style={style}>
						<label>{renderLabel?.({ name, label, ...props }) || label}</label>

						{renderChildren(field, { name, ...props })}
					</div>
				))}
		</Form.Group>
	);
}
